// extracted by mini-css-extract-plugin
module.exports = {"Product":"Product_Product__loW80","Info":"Product_Info__DgClp"};